<template>
  <section>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      fixed
      app
      width="215"
    >
      <v-list dense v-if="user.admin == true && user.editor == false && user.manager == false">
        <template v-for="item in adminItems">
          <v-layout v-if="item.heading" :key="item.heading" row align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="(child, i) in item.children" :key="i" :to="child.link">
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ child.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile :to="item.link" v-else-if="item.text != 'Logout'" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout()" v-else-if="item.text == 'Logout'" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <v-list dense v-if="user.admin == false && (user.editor == true || user.manager == false)">
        <template v-for="item in editorItems">
          <v-layout v-if="item.heading" :key="item.heading" row align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="(child, i) in item.children" :key="i" :to="child.link">
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ child.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile :to="item.link" v-else-if="item.text != 'Logout'" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout()" v-else-if="item.text == 'Logout'" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <v-list dense v-if="user.admin == false && (user.editor == false || user.manager == true)">
        <template v-for="item in managerItems">
          <v-layout v-if="item.heading" :key="item.heading" row align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="(child, i) in item.children" :key="i" :to="child.link">
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ child.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile :to="item.link" v-else-if="item.text != 'Logout'" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout()" v-else-if="item.text == 'Logout'" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="primary" dark app fixed flat>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <a :href="`${webUrl}`" target="_blank">
        <!-- <span class="hidden-sm-and-down" style="color: #fff">{{appName}}</span> -->
        <span style="color: #fff">{{appName}}</span>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <v-btn icon large>
        <v-icon>person_outline</v-icon>
      </v-btn>
    </v-toolbar>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["appName"]),
    ...mapGetters(["webUrl"]),
    ...mapGetters(["user"])
  },
  data: () => ({
    dialog: false,
    drawer: null,
    adminItems: [
      { icon: "dashboard", text: "Dashboard", link: "/dashboard" },
      { icon: "supervised_user_circle", text: "Editors", link: "/editors" },
      { icon: "supervised_user_circle", text: "Managers", link: "/managers" },
      { icon: "dashboard", text: "Tickets", link: "/ticketreplies/sonko" },
      { icon: "dashboard", text: "Blogs", link: "/blogs" },
      { icon: "timelapse", text: "Experts", link: "/experts" },
      {
        icon: "supervised_user_circle",
        text: "Sonkos",
        link: "/sonkos"
      },
      {
        icon: "supervised_user_circle",
        text: "VIP Sonkos",
        link: "/vip_sonkos"
      },
      {
        icon: "supervised_user_circle",
        text: "Expertise Categories",
        link: "/categories"
      },
      { icon: "settings", text: "Packages", link: "/settings" },
      { icon: "view_stream", text: "Projects", link: "/projects" },
      { icon: "build", text: "Jobs", link: "/jobs" },
      { icon: "star", text: "Project Ratings", link: "/projectratings" },
      { icon: "star", text: "Expert Ratings", link: "/expertratings" },
      { icon: "dashboard", text: "Blog Comments", link: "/blogcomments" },
      { icon: "view_stream", text: "Donations", link: "/donations" },
      { icon: "view_stream", text: "Workshops", link: "/workshops" },
      { icon: "call", text: "Update Number", link: "/updatephone" },
      { icon: "build", text: "Update Password", link: "/updatepassword" },
      { icon: "logout", text: "Logout", link: "/logout" }
    ],
    editorItems: [
      { icon: "dashboard", text: "Dashboard", link: "/dashboard" },
      { icon: "dashboard", text: "Tickets", link: "/ticketreplies/sonko" },
      { icon: "dashboard", text: "Blogs", link: "/blogs" },
      { icon: "timelapse", text: "Experts", link: "/experts" },
      {
        icon: "supervised_user_circle",
        text: "Sonkos",
        link: "/sonkos"
      },
      {
        icon: "supervised_user_circle",
        text: "VIP Sonkos",
        link: "/vip_sonkos"
      },
      { icon: "view_stream", text: "Projects", link: "/projects" },
      { icon: "build", text: "Jobs", link: "/jobs" },
      { icon: "star", text: "Project Ratings", link: "/projectratings" },
      { icon: "star", text: "Expert Ratings", link: "/expertratings" },
      { icon: "dashboard", text: "Blog Comments", link: "/blogcomments" },
      { icon: "logout", text: "Logout", link: "/logout" }
    ],
    managerItems: [
      { icon: "dashboard", text: "Dashboard", link: "/dashboard" },
      { icon: "supervised_user_circle", text: "Editors", link: "/editors" },
      { icon: "dashboard", text: "Tickets", link: "/ticketreplies/sonko" },
      { icon: "dashboard", text: "Blogs", link: "/blogs" },
      { icon: "timelapse", text: "Experts", link: "/experts" },
      {
        icon: "supervised_user_circle",
        text: "Sonkos",
        link: "/sonkos"
      },
      {
        icon: "supervised_user_circle",
        text: "VIP Sonkos",
        link: "/vip_sonkos"
      },
      {
        icon: "supervised_user_circle",
        text: "Expertise Categories",
        link: "/categories"
      },
      { icon: "view_stream", text: "Projects", link: "/projects" },
      { icon: "build", text: "Jobs", link: "/jobs" },
      { icon: "star", text: "Project Ratings", link: "/projectratings" },
      { icon: "star", text: "Expert Ratings", link: "/expertratings" },
      { icon: "dashboard", text: "Blog Comments", link: "/blogcomments" },
      { icon: "view_stream", text: "Workshops", link: "/workshops" },
      { icon: "call", text: "Update Number", link: "/updatephone" },
      { icon: "build", text: "Update Password", link: "/updatepassword" },
      { icon: "logout", text: "Logout", link: "/logout" }
    ]
  }),
  methods: {
    logout() {
      this.$store.commit("removeUser");
      localStorage.removeItem("token");
      this.$router.push(`/login`);
    }
  }
};
</script>
